export const supportCategories = [
  { value: 'game', label: '游戏问题', description: '加载、存档、联机' },
  { value: 'account', label: '账号与权益', description: '登录、会员、奖励' },
  { value: 'suggestion', label: '意见建议', description: '功能、体验、新想法' },
  { value: 'other', label: '其他问题', description: '其他疑问与合作' },
] as const;
export const supportCategoryLabels: Record<string, string> = {
  ...Object.fromEntries(supportCategories.map((c) => [c.value, c.label])),
  bug: '问题报告（历史）',
  contact: '联系管理员（历史）',
};
